<template>
  <div class="bg-white rounded">
    <div class="text-left title-grey border h5 p-3 title-rounded font-weight-bold">{{subTitle}}</div>
    <div class="text-intent pl-3 pr-3 pt-4 pb-4" v-html="subContent"></div>
  </div>
</template>

<script>
  export default {
    name: 'standardFrame',
    props:['subTitle','subContent']
  }
</script>

<style scoped lang="scss">
  .title-rounded{
    border-radius: 5px 5px 0 0;
  }
  .text-intent {
    text-indent: 35px;
    text-align: left;
    line-height: 25px;
    font-size: 14px;
  }
</style>
